export default __webpack_public_path__ + "static/media/GCash_Payment_Confirmation.f2eba33f.png";